import PropTypes from 'prop-types';
import React from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import styles from './Sidebar.module.css';

export default function SidebarSection({
  title,
  Icon,
  expanded,
  onToggle,
  children,
}) {
  return (
    <li style={{ padding: 0, margin: 0 }}>
      <button
        type="button"
        className={styles.sectionToggle}
        onClick={onToggle}
        aria-expanded={expanded}
      >
        <Icon size={24} />
        <span className={styles.sectionToggleTitle}>{title}</span>
        {expanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
      </button>
      {expanded && children}
    </li>
  );
}

SidebarSection.propTypes = {
  title: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  Icon: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
